import { useFindByQuery } from '../../graphql';

export const useAllAddOns = (workspaceId: string) => {
  const { data, isLoading } = useFindByQuery({
    modelName: 'addon',
    query: FIND_ADDONS,
    variables: { filter: { workspace: { eq: workspaceId } } },
  });

  return {
    addons: data?.items,
    isLoading,
  };
};

const FIND_ADDONS = `
  query FindAddons($filter: AddonFilter) {
    findAddons(filter: $filter) {
      items {
        id        
        name
      }
    }
  }
`;
